import type { ComputerViewModel, PersonalDataItemViewModel } from '@trinnvis/dabih-api-client';
import type { Sector } from '../../types';

export const computerHasMedicalData = function (
  c: ComputerViewModel & { personalDataItems: PersonalDataItemViewModel[] },
  sector?: Sector,
): boolean {
  // For non-health sectors, medical data detection should always return false
  if (sector && sector !== 'HEALTH') {
    return false;
  }

  const items = c.personalDataItems.filter((item) => item.type?.startsWith('patientData'));
  return items.length > 0;
};
